import PropTypes from 'prop-types';
import { useCallback } from "react";
import { Dropdown } from "react-bootstrap";
import Button from "./Button";
import Icon from "./Icon";

/**
 * Standard action-style dropdown with Chrono button styling.
 * @component
 */
const ChronoDropdown = ({ id, label, icon, variant = 'default', disabled = false, className, toggleClassName, menuClassName, renderIndicator, onToggle, children, ...props }) => {
    const handleToggle = useCallback((show, event, metadata) => {
        onToggle?.(show, event, metadata);
    }, [onToggle]);

    const indicator = renderIndicator ? renderIndicator(false) : <Icon intent="collapse"></Icon>;

    return <Dropdown {...props} className={`chrono-dropdown${className ? ` ${className}` : ''}`} onToggle={handleToggle}>
        <Dropdown.Toggle as={Button} id={id} variant={variant} layout="stacked" className={`chrono-select chrono-toggle-icon${toggleClassName ? ` ${toggleClassName}` : ''}`} disabled={disabled}>
            <span className="chrono-toggle-main">
                {icon}
                <span>{label}</span>
            </span>
            {indicator ? <span className="chrono-toggle-indicator">{indicator}</span> : null}
        </Dropdown.Toggle>
        <Dropdown.Menu className={menuClassName}>
            {children}
        </Dropdown.Menu>
    </Dropdown>
}

ChronoDropdown.propTypes = {
    id: PropTypes.string,
    label: PropTypes.node.isRequired,
    icon: PropTypes.node.isRequired,
    variant: PropTypes.string,
    disabled: PropTypes.bool,
    className: PropTypes.string,
    toggleClassName: PropTypes.string,
    menuClassName: PropTypes.string,
    renderIndicator: PropTypes.func,
    onToggle: PropTypes.func,
    children: PropTypes.node
}

const ActionDropdown = ChronoDropdown;

export { ActionDropdown };
export default ActionDropdown;
